import React from 'react';
import { Alert, AlertTitle, Box } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import AlertPopup from '../alertPopup';
import { STATUS_CONFIG } from '../../../constants';

const StatusAlert = ({ status, message, reports }) => {
  const normalizedStatus = status?.toLowerCase?.();
  const config = STATUS_CONFIG[normalizedStatus] || STATUS_CONFIG.failed;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        mt: '4px',
        p: 0,
        borderRadius: 2,
        bgcolor: config.bg,
        border: `1px solid ${config.border}`,
      }}
    >
      <Alert
        icon={<InfoOutlinedIcon style={{ color: config.icon }} />}
        sx={{
          flexGrow: 1,
          bgcolor: 'transparent',
          color: config.color,
          '.MuiAlertTitle-root': {
            fontWeight: 700,
            color: config.color,
          },
        }}
        className="status-alert"
      >
        <AlertTitle className="text-capitalize">{status}</AlertTitle>
        <p className="mb-0 text-capitalize">{message}</p>
      </Alert>
      <AlertPopup isCaseSucess={status} details={reports} />
      </Box>
  );
};

export default StatusAlert;
